module.exports = __webpack_public_path__ + "img/ic_change_password.eec5d6ba.svg";